import React, { useState } from "react";
import Select from "react-select";

type Option = {
  value: string;
  label: string;
};


interface Props {
  onChange: (values: string[]) => void;
  Options:Option[];
  docs?:any[];
}

const MultiSelectCheckbox: React.FC<Props> = ({ onChange , Options , docs }) => {
  const [selected, setSelected] = useState<Option[]>([]);

  // const filteredOptions = docs
  // ? Options.filter((option) =>
  //     docs.some((doc) => doc.docName === option.value)
  //   )
  // : [];

  const highSchoolIndex = Options.findIndex(option => option.value === "highSchool");
  
  // Separate fixed options (before highSchool)
  const fixedOptions = Options.slice(0, highSchoolIndex);
  
  // Get document names from docs array
  const validDocumentNames = new Set(docs.map(doc => doc.documentName));
  
  // Filter dynamic options (from highSchool onward) based on docs
  const filteredOptions = Options.slice(highSchoolIndex).filter(option => validDocumentNames.has(option.value));

  // Merge both lists
  const finalOptions = [...fixedOptions, ...filteredOptions,{ value: "otherDoc", label: "Additional other Document" }];

  

  const handleChange = (selectedOptions: Option[] | null) => {
    setSelected(selectedOptions || []);
    onChange(selectedOptions ? selectedOptions.map(option => option.value) : []);
  };

  return (
    <Select
    options={finalOptions && finalOptions.length > 0 ? finalOptions : Options}
    isMulti
    value={selected}
    onChange={handleChange}
    closeMenuOnSelect={false}
    placeholder="Select options..."
  />
  );
};

export default MultiSelectCheckbox;
